export enum ApplicationCode {
	CUSTOMER_INFO = 'CustomerInfo_App',
	USER_PROVISIONING = 'UserProvisioning_App',
}

export const appCode = ApplicationCode.CUSTOMER_INFO
export const appsContainer = 'cemexApps'
export const appRootNode = 'app-customer-info-launcher'
